import { lazy } from 'react';

// Temas especiales opcionales configurables por tienda.
// Un tema seleccionado se puede aplicar sobre cualquier diseno predeterminado.
// Los módulos se descargan cuando la tienda realmente usa este tema.
export const STORE_CUSTOM_THEMES = {
  'libreria-regaleria': {
    key: 'libreria-regaleria',
    className: 'store-theme-libreria-regaleria',
    Home: lazy(() => import(/* webpackChunkName: "theme-libreria-home" */ 'views/Home/HomeLibreria')),
    Header: lazy(() => import(/* webpackChunkName: "theme-libreria-header" */ 'components/commons/BrandHeaderLibreria')),
    CartDrawer: lazy(() => import(/* webpackChunkName: "theme-libreria-cart" */ 'components/commons/CartDrawerLibreria')),
  },
};

export const getCustomStoreTheme = (client) => {
  const themeKey = client?.custom_design_settings?.theme;
  return STORE_CUSTOM_THEMES[themeKey] ? themeKey : null;
};

export const getCustomStoreThemeDefinition = (clientOrKey) => {
  const themeKey = typeof clientOrKey === 'string' ? clientOrKey : getCustomStoreTheme(clientOrKey);
  return STORE_CUSTOM_THEMES[themeKey] || null;
};
